import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001',
});

const getOwner = () => {
    return localStorage.getItem('tournamentOwner') || '00000000-0000-0000-0000-000000000000';
}

// Leagues
export const getLeagues = () => api.get('/leagues', { params: { owner: getOwner() } });
export const createLeague = (league) => api.post('/leagues', league, { params: { owner: getOwner() } });
export const updateLeague = (id, league) => api.put(`/leagues/${id}`, league, { params: { owner: getOwner() } });
export const deleteLeague = (id, deleteTeams) => api.delete(`/leagues/${id}`, { params: { deleteTeams, owner: getOwner() } });
export const getTeamsForLeague = (leagueId) => api.get(`/leagues/${leagueId}/teams`, { params: { owner: getOwner() } });
export const updateLeagueOrder = (leagueIds) => api.post('/leagues/order', { leagueIds }, { params: { owner: getOwner() } });

// Teams
export const getTeams = () => api.get('/teams', { params: { owner: getOwner() } });
export const createTeam = (team) => api.post('/teams', team, { params: { owner: getOwner() } });
export const updateTeam = (id, team) => api.put(`/teams/${id}`, team, { params: { owner: getOwner() } });
export const deleteTeam = (id) => api.delete(`/teams/${id}`, { params: { owner: getOwner() } });

// Games
export const getGames = (leagueId) => api.get(`/leagues/${leagueId}/games`, { params: { owner: getOwner() } });
export const generateGames = (leagueId) => api.post(`/leagues/${leagueId}/games/generate`, {}, { params: { owner: getOwner() } });
export const updateGame = (id, game) => api.put(`/games/${id}`, game, { params: { owner: getOwner() } });
export const deleteGame = (id) => api.delete(`/games/${id}`, { params: { owner: getOwner() } });

// Standings
export const getStandings = (leagueId) => api.get(`/leagues/${leagueId}/standings`, { params: { owner: getOwner() } });

export default api;

